<div class="pressure">
  <div class="header small">
    <div class="inside">
      <div id="logo"><a href="index.html" title="Startseite"><img ngSrc="./assets/logo.jpg"
                                                                  alt="DRIVOSOL® Tuner" height="225" width="553"></a></div>
      <div class="cat-icon"><svg class="icon">
        <use xlink:href="#icon-pressure"></use>
      </svg></div>
      <div id="evonik_logo"><img ngSrc="./assets/evonik_logo.png" alt="Evonik" height="76" width="294"></div>
    </div>
  </div>
  <div class="section pressurebox">
    <div class="inside">
      <div class="milkybox">
        <h2 i18n="@@pressure_title">Gewünschter Druck</h2>
        <div class="labelholder">
          <app-slider [min]="1.2" [max]="7.8" (change)="changeSlider($event)"></app-slider>
          <div id="rangeslider_pressure"></div>
          <div class="labelstart">1,2</div>
          <div class="labelend">7,8</div>
        </div>
        <div class="pressure_input">
          <label for="">Bar</label>
          <div class="input_wrapper">

            <input id="slider-range-value" #numberInput type="number" [value]="pressure" (change)="changeInput($event)" maxlength="3">
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (matchingProducts.length > 0) {
    <app-product-table [products]="matchingProducts" mode="pressure" i18n="@@products">PRODUCTS</app-product-table>
  }
  @if (similarProducts.length > 0) {
    <app-product-table [products]="similarProducts" mode="pressure" i18n="@@similar_products">PRODUCTS WITH SIMILAR PRESSURE</app-product-table>
  }
</div>
